import React, { useState, useEffect } from 'react';
import '../styles.css';

export default function Login() {
  const [redirectPath, setRedirectPath] = useState('/dashboard');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Parse query string (e.g. ?redirect=/somewhere)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const redirect = params.get('redirect');
    if (redirect) setRedirectPath(redirect);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('https://api.fotomate.ai/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        // API returns { error: '...' }
        throw new Error(data.error || 'Authentication failed');
      }
      // Store token (e.g. JWT)
      localStorage.setItem('token', data.token);
      // Redirect on success
      window.location.href = redirectPath;
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <section className="contact">
      <h2>Login</h2>
      <form onSubmit={handleSubmit} className="login-form">
        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {error && <div className="error-message">{error}</div>}
        <button type="submit" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
      <div className="login-links">
        <a href="/forgot-password">Forgot Password?</a>
        <a href="/register">Register Account</a>
      </div>
    </section>
  );
}
